import React, { Component } from 'react'
import { Button, Col, Empty, Form, Input, Row, Select, Table } from 'antd';
import { connect } from 'react-redux';
import {fetchAssignAbleOrder,assignDriver} from '../../../../action/parcel'
import {fetchDrivers} from '../../../../action/drivers'
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from "react-highlight-words";
import Header from '../../../../components/header';
const { Option } = Select;
class AssignParcels extends Component {
  state = { 
    searchText: '',
    searchedColumn: '',
    data: [],
    drivers: '',
    rider: '',
    expandedRowKeys: []
   } 
    componentDidMount = () => {
        this.getData()
        this.getDrivers()
    };
    getData = async () => {
        const res = await this.props.fetchAssignAbleOrder()
        this.setState({data: res})
    }
    getDrivers = async () => {
      const res = await this.props.fetchDrivers()
      this.setState({drivers: res})
    }
    createOption = (label, value) => {
      return { label, value };
    };
   
  
    getColumnSearchProps =  dataIndex => ({
        filterDropdown:  ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
            ref={node => {
                this.searchInput = node;
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => {setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
                this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
                });}}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
            />
            {/* <Space>
            <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
            >
                Search
            </Button>
            <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                Reset
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({ closeDropdown: false });
                this.setState({
                    searchText: selectedKeys[0],
                    searchedColumn: dataIndex,
                });
                }}
            >
                Filter
            </Button>
            </Space> */}
        </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
        record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
        if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
        }
        },
        render: text =>
        this.state.searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });
    
    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
        });
    };

    createData = (key,store_info,details,customer_info,order_time,type,action) => {
        return {key,store_info,details,customer_info, order_time,type,action};
    };

    makeLocalTime = (date) => {
        let mainDate = date.split('T')[0];
        let hours = date.split('T')[1].split(':')[0];
        let minutes = date.split('T')[1].split(':')[1];
        var am = true;
        if (hours > 12) {
            am = false;
            hours -= 12
        } else if (hours == 12) {
            am = false;
        } else if (hours == 0) {
            hours = 12
        }
        return mainDate + " , " + hours+":"+minutes + " " + (am ? "a.m" : "p.m")
    }

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    handleSubmit = async (order_id) => {
      if(this.state.rider === ''){
        alert('Please select a rider')
      }else{
        const res = await this.props.assignDriver(order_id,this.state.rider)
        if(res === 201){
            this.getData()
        }
      }
    }
    
    onDriverChange = async (e) => {
      this.setState({rider: e})
    }
    onTableRowExpand = (expanded, record) => {
      const keys = [];
      if(expanded){
          keys.push(record.id); // I have set my record.id as row key. Check the documentation for more details.
      }
      this.setState({expandedRowKeys: keys})
  }
  render() { 
    
    const columns = [
     
      {
        title: 'Order ID',
        dataIndex: 'key',
        key: 'key',
        width: '15%',
        ...this.getColumnSearchProps('key'),
      },
      {
        title: 'Store Info',
        dataIndex: 'store_info',
        key: 'store_info',
        width: '20%',
        ...this.getColumnSearchProps('store_info'),
      },
      {
        title: 'Customer Info',
        dataIndex: 'customer_info',
        key: 'customer_info',
        width: '20%',
        ...this.getColumnSearchProps('customer_info'),
      },
      {
        title: 'Order Time',
        dataIndex: 'order_time',
        key: 'order_time',
        width: '12%',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        width: '12%',
      },
      
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        width: '10%'
      }
    ];
    const {data, drivers} = this.state
    const rows = [...
      data
        ? data?.map((item,id) => this.createData(
           
            item.order_id
            , 
            item?.shop?.name + '(' + item?.shop?.mobile_number +')'
            ,
            <Row gutter={12}>
              <Col xs={12}>
                <h3>Shop</h3>
                <p style={{margin: '2px 0px'}}>{item?.shop?.shop_id}</p>
                <p style={{margin: '2px 0px'}}>{item?.shop?.name}</p>
                <p style={{margin: '2px 0px'}}>{item?.shop?.mobile_number}</p>
                <p style={{margin: '2px 0px'}}>{item?.shop?.address}</p>
              </Col>
              <Col xs={12}>
                <h3>Customer</h3>
                <p style={{margin: '2px 0px'}}>{item?.recipient_name}</p>
                <p style={{margin: '2px 0px'}}>{item?.recipient_mobile_number}</p>
                <p style={{margin: '2px 0px'}}>{item?.recipient_address}</p>
              </Col>
            </Row>
            ,
            item?.recipient_name + '(' + item?.recipient_mobile_number + ')'
            
            ,
              this.makeLocalTime(item?.created_at)
            ,
              item?.type
            , 
            <Button size="large" type="primary" onClick={() => this.handleSubmit(item?.order_id)} >Assign</Button>
            
            
          ))
        : "",
    ];
    
    const options = [
      drivers
        ? drivers?.map((item) =>
            this.createOption(
              `${item.mobile_number}----` + item.name,
              item.user_id
            )
          )
        : null,
    ];
    return (
      <>
        
        <Header title="Assign Parcels" subtitle="Parcel"  name="normal_order" />
        <br />
        <Form.Item name="rider" label="Select a rider">
          <Select
            style={{width: '100%'}}
            size = "large"
            showSearch
            placeholder="Select a rider"
            optionFilterProp="children"
            onChange={this.onDriverChange}
            value={this.state.rider}
            // onSearch={onSearch}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {options[0]? 
            options[0]?.map((item,id) => (
              <Option value={item?.value}>{item?.label}</Option>
            ))
          :null}
          </Select>
        </Form.Item>
            {rows?.length > 0
              ? 
                <Table columns={columns} dataSource={rows} scroll={{ x: 1000 }} sticky
                rowClassName={(record) => record?.type == 'NO' ? 'table-row-light' :  'red'} 
                rowkey={(record) => console.log(record.key)} 
                expandable={{
                  expandedRowRender: record => <p style={{ margin: 0 }}>{record.details}</p>,
                  expandRowByClick: true
                  
                }}
                />
            : 
            <Empty />}
      </>
    );
  }
}

export default connect(null,{fetchAssignAbleOrder,fetchDrivers,assignDriver})(AssignParcels);